export const TEAM_PAGINATION_SIZE = 20
